<template>
  <div class="form-container step1">
    <form id="topup-codes-step1" @submit.prevent="submit">
      <div class="form-row">
        <section v-for="(group, key) in productsGroups" :key="'group-' + key" class="operator-group">
          <h3>{{ group.label }}</h3>
          <ul class="operator-list">
            <li v-for="product in group.products" :key="product" class="operator-item">
              <label :for="product">
                <img :src="getOperatorLogoSrc(product)" :alt="product">
                <input type="radio"
                       @change="checkForm"
                       :value="product"
                       v-model="form.data.product"
                       :id="product">
                <span class="outline"></span>
              </label>
            </li>
          </ul>
        </section>
        <div class="error" v-if="form.isSubmited && !form.isValid">Wybierz produkt</div>
      </div>
      <div class="form-row form-buttons">
        <button type="submit" class="btn">Dalej</button>
      </div>
    </form>
  </div>
</template>

<script>
import OperatorMixin from '@/doladujtutaj/mixins/operator.mixin'
import { mapActions, mapMutations } from 'vuex'
import { PRODUCTS_CODES_GROUPS } from '@/common/const/operators.const'
import { ToolsClass } from '@/common/class/tools.class'

export default {
  name: 'TopupCodesStep1',
  mixins: [OperatorMixin],
  computed: {
    productsGroups: function () {
      return PRODUCTS_CODES_GROUPS
    }
  },
  data () {
    return {
      form: {
        data: {
          product: null
        },
        isValid: false,
        isSubmited: false
      }
    }
  },
  methods: {
    ...mapMutations(['SET_VOUCHER_STAGE']),
    ...mapActions([
      'setVoucherData',
      'resetVoucherTopup'
    ]),
    checkForm () {
      this.form.isValid = !!this.form.data.product
    },
    submit () {
      this.form.isSubmited = true
      if (!this.form.isValid) {
        return
      }
      this.setVoucherData(this.form.data)
        .then(() => {
          this.SET_VOUCHER_STAGE(2)
        })
    }
  },
  created () {
    this.resetVoucherTopup()
    this.checkForm()
  },
  updated () {
    ToolsClass.sendHeightToIframeParent()
  }
}
</script>
